import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { setBox, clearBoxErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

 const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  box: PropTypes.object,
  error: PropTypes.any,
};

 class BoxesNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: '',
        length: 0,
        width: 0,
        height: 0,
        boxWeight: 0,
        weightLimit: 0,
        weightAvailable: 0
      },
      box: {
        sequence: 0,
        name: '',
        length: 0,
        width: 0,
        height: 0,
        boxWeight: 0,
        weightLimit: 0,
        weightAvailable: 0,
        approved: false,
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.box && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Box saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { required, box } = this.state
    Object.keys(required).forEach((paramName) => {
      const param = box[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const nextState = this.state.box
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked)
    } else {
      _.set(nextState, e.target.name, e.target.value)
    }
    nextState.weightAvailable = nextState.weightLimit - nextState.boxWeight
    this.setState({
      box: nextState,
    })
    this.setRequiredParams()
  }
  handleSubmit() {
    this.props.dispatch(clearBoxErrors());
    const pBox = this.state.box;
    console.log('BOX IN STATE', pBox)
    this.props.dispatch(setBox(pBox));
  }
  handleCancel() {
    this.props.dispatch(clearBoxErrors());
    browserHistory.push('/boxes');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/boxes');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      }
    };
    return (
      <div className="boxes component" style={authPage}>
        <h2>New Box</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div>
            <TextField
              floatingLabelText="Sequence"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.box.sequence}
              name="sequence"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.sequence}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.box.name}
              name="name"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.name}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Length"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.box.length}
              name="length"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.length}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Width"
              floatingLabelStyle={styles.floatingLabelStyle}
              type="number"
              value={this.state.box.width}
              name="width"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.width}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Height"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.box.height}
              name="height"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.height}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Box weight"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.box.boxWeight}
              name="boxWeight"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.boxWeight}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Weight Limit"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.box.weightLimit}
              name="weightLimit"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.weightLimit}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Weight Available"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.box.weightAvailable}
              name="weightAvailable"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.weightAvailable}
              errorStyle={{ color: cyan500 }}
              type="number"
              disabled
            />
            <br /><br /><br />
            <Checkbox
              label="Approved"
              defaultChecked={this.state.box.approved}
              name="approved"
              onCheck={this.handleChange}
              />
          </div>
        </div>
      </div>
    );
  }
}
 BoxesNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};
 BoxesNewPage.propTypes = propTypes;

 function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    // error: state.box.error,
  };
}

 export default withRouter(connect(mapStateToProps)(BoxesNewPage))


// WEBPACK FOOTER //
// ./src/containers/BoxesNewPage.js